import React, { useState, useEffect } from "react";
import "./OurClients.css";

import c1 from "../../assets/images/client1.jpg";
import c2 from "../../assets/images/client2.png";
import c3 from "../../assets/images/client3.jpg";
import c4 from "../../assets/images/client4.jpg";
import c5 from "../../assets/images/client5.jpg";
import c6 from "../../assets/images/client6.jpg";
import c7 from "../../assets/images/client7.jpg";
import c8 from "../../assets/images/client8.jpg";
import c9 from "../../assets/images/client9.jpg";
import c10 from "../../assets/images/client10.jpg";
import c11 from "../../assets/images/client11.jpg";
import c12 from "../../assets/images/client12.jpg";
import c13 from "../../assets/images/client13.jpg";
import c14 from "../../assets/images/client14.jpg";
import c15 from "../../assets/images/client15.jpg";
import c16 from "../../assets/images/client16.png";
import c17 from "../../assets/images/client17.png";
import c18 from "../../assets/images/client18.png";
import c19 from "../../assets/images/client19.png";




const images = [
  c1, c2, c3, c4, c5,
  c6, c7, c8, c9, c10,
  c11, c12, c13, c14, c15,c16,c17,c18,c19
];

export default function OurClients() {
  const [hovered, setHovered] = useState(null);
  const [scrollAnim, setScrollAnim] = useState(false);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".client-section");
      if (!section) return;

      const top = section.getBoundingClientRect().top;
      if (top < window.innerHeight - 150) {
        setScrollAnim(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="client-section">
      <div className="client-container">

        <h2 className={`client-heading scroll-anim ${scrollAnim ? "show" : ""}`}>
          Our Estimated Clients
        </h2>

        <div className="scroll-line">
          <div className="line-inner"></div>
        </div>

        <div className="client-grid">
          {images.map((img, i) => (
            <div
              key={i}
              className="client-card"
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <img
                src={img}
                alt={`client-${i}`}
                className={`client-img ${hovered === i ? "img-hover" : ""}`}
              />

              {hovered === i && (
                <div className="client-overlay">{i + 1}</div>
              )}
            </div>
          ))}
        </div>

      </div>

      {/* ⭐ This stays at bottom, center, visible */}
      {/* <p className={`more-text scroll-anim ${scrollAnim ? "show" : ""}`}>
        .....and so many more!!!
      </p> */}

    </section>
  );
}
